export default {
      id: "plane-usage",
      viewBox: "0 0 26 22",
      url: __webpack_public_path__ + "img/icons.deccda40.svg#plane",
      toString: function () {
        return this.url;
      }
    }